module.exports = __webpack_public_path__ + "img/illustration-mockups.129756c2.svg";